// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"latest_imgBox__YHqDn","description":"latest_description__2l0_g","price":"latest_price__2wIhZ"};